import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { APPLE_PAY, CB, GOOGLE_PAY, PAYPAL } from '../../../constants/paymentMethods';

import { scrollToTop } from '../../../utils';

import Paypal from './payment-choice/Paypal';
import ApplePay from './payment-choice/ApplePay';
import GooglePay from './payment-choice/GooglePay';
import CreditCard from './payment-choice/CreditCard';
import KycMessage from './kyc-message/KycMessage';

import { PaymentSelectionContainer } from './FunnelPaymentSelectionStepStyle';

const FunnelPaymentSelectionStep = ({
    kycNeeded,
    setPaymentType,
    i18n,
    ebonPaymentConfig,
    paymentMethods,
    userInfo,
    partnerId,
    order
}) => {
    const [selectedMethod, setSelectedMethod] = useState();

    useEffect(() => {
        scrollToTop();
    }, []);

    const handleMethodChange = value => {
        if (selectedMethod !== value) {
            setSelectedMethod(value);
            setPaymentType(value);
        }
    };

    const checkoutAllowed = ebonPaymentConfig.checkoutAllowed && paymentMethods.includes(CB);
    const googlePayAllowed =
        ebonPaymentConfig.googlePayAllowed && paymentMethods.includes(GOOGLE_PAY);
    const applePayAllowed = ebonPaymentConfig.applePayAllowed && paymentMethods.includes(APPLE_PAY);
    const paypalAllowed = ebonPaymentConfig.paypalAllowed && paymentMethods.includes(PAYPAL);

    return (
        <PaymentSelectionContainer>
            {kycNeeded && <KycMessage text={i18n.KYC_MESSAGE} />}

            {checkoutAllowed && (
                <CreditCard
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                    userInfo={userInfo}
                    partnerId={partnerId}
                    order={order}
                />
            )}

            {paypalAllowed && (
                <Paypal selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}

            {googlePayAllowed && (
                <GooglePay
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}

            {applePayAllowed && (
                <ApplePay selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}
        </PaymentSelectionContainer>
    );
};

FunnelPaymentSelectionStep.propTypes = {
    kycNeeded: PropTypes.bool,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    order: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || []
    };
};

export default withRouter(connect(mapStateToProps)(FunnelPaymentSelectionStep));



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/FunnelPaymentSelectionStep.js